module.exports = __webpack_public_path__ + "static/media/DK2048_04.7e89bc61.jpg";